//@flow
import env from '../../../environment';
import {
  getCreator,
  postCreator,
  deleteCreator,
  putCreator,
} from '../../../http';

export const endpoints = Object.freeze({
  // GET_CATEGORY_LAYOUT: `${env.baseApiUrl}/ui/admin/store/store-location`,
  GET_STORE_INFORMATION_BLOCK: `${env.baseApiUrl}/ui/admin/store/store-information-block/:blockId`,
  LIST_STORE_INFORMATION_BLOCKS: `${env.baseApiUrl}/ui/admin/store/store-information-block`,
  CREATE_STORE_INFORMATION_BLOCK: `${env.baseApiUrl}/ui/admin/store/store-information-block`,
  UPDATE_STORE_INFORMATION_BLOCK: `${env.baseApiUrl}/ui/admin/store/store-information-block/:blockId`,
  DELETE_STORE_INFORMATION_BLOCK: `${env.baseApiUrl}/ui/admin/store/store-information-block/:blockId`,
});

export const getStoreInformationBlockApi = getCreator(
  endpoints.GET_STORE_INFORMATION_BLOCK
);

export const listStoreInformationBlocksApi = getCreator(
  endpoints.LIST_STORE_INFORMATION_BLOCKS
);

export const createStoreInformationBlockApi = postCreator(
  endpoints.CREATE_STORE_INFORMATION_BLOCK
);

export const updateStoreInformationBlockApi = putCreator(
  endpoints.UPDATE_STORE_INFORMATION_BLOCK
);

export const deleteStoreInformationBlockApi = deleteCreator(
  endpoints.DELETE_STORE_INFORMATION_BLOCK
);
